module.exports = __webpack_public_path__ + "img/19_ABATTAGE-TAMARIN_min.61126935.jpg";